import React, { Fragment, useState, useEffect } from 'react';
import FileSaver from 'file-saver';
import SubHeader from './subHeader/subHeader';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import SearchFilter from 'b2b-ui-components-lib/lib/components/searchFilter';
import Select from 'b2b-ui-components-lib/lib/components/select';
import Pagination from 'b2b-ui-components-lib/lib/components/pagination';
import Table from 'b2b-ui-components-lib/lib/components/table';
import Alert_icon from 'dedicated/components/images/alert-icon-warning.svg';
import Alert_red from 'assests/svg/alert_red.svg';
import Cross_icon from 'assests/svg/cross-icon.svg';
import './addressProcess.scss';
import ProcessComponent from './processComponent/processComponent';
import ProgressComponent from './progressComponent/progressComponent';
import StatusList from './statusList/statusList';
import NoRecord from './NoRecord';


import Ripple from 'b2b-ui-components-lib/lib/components/ripple';
import TableLoaderComponent from 'home/view/manage-feasibility/components/organisms/addressProcessAOI/loader/table-loader';
import { FEASIBILITY_LOCATION_STATUS, FEASIBILITY_MESSAGE } from 'home/view/manage-feasibility/constants/multiSite-constants';
import { getProductType, isAOIOrder, PRODUCT_TYPE } from 'common/constants/app.constants';
import Button from 'b2b-ui-components-lib/lib/components/button';
import Tooltip from '../../../../../../common/components/tooltip-component/tooltip-component';
const AddressProcess = ({
  setBottomMargin = true,
  showSubHeader = false,
  showTableData = true,
  productTitle = 'Buy a Dedicated Internet Plan',
  handleGoBack = () => {},
  hasAccordion = false,
  isAccordionExpanded = false,
  setIsAccordionExpanded = (value) => {},
  showProcessComponent = false,
  showProcessConfigSection = false,
  processIdLabel = '',
  processId = '',
  processSiteLabel = '',
  processSiteProcessed = 0,
  processBtnDisabled = false,
  processBtnName = 'Edit with Excel',
  showDownloadReport=false,
  onProcessBtnClick = () => {},
  showAddressErrorStatus = false,
  locationStatusMap = {},
  showFeasibilityErrorStatus = false,
  feasibleSites = 0,
  manualFeasibleSites = 0,
  notFeasibleSites = 0,
  pendingFeasibleSites = 0,
  pendingForThirdPartySites = 0,
  showProgressComponent = false,
  noOfProcessingSites = 0,
  percentageComplete = 0,
  showFilterOptions = false,
  filterLabel = '',
  filterValue = {},
  filterOptions = [],
  filterOnChange = (value) => {},
  searchType = {},
  onSearchTypeChange = (value) => {},
  searchValue = '',
  onSearchValueChange = (value) => {},
  searchTypeOptions = [],
  searchFilterOptions = {},
  onSearchClick = () => {},
  onClearFilter = (value) => {},
  rows = [],
  cols = [],
  dataPerPageLabel = '',
  dataPerPageValue = {},
  dataPerPageOptions = [],
  dataPerPageOnChange,
  totalPages = 0,
  currentPage = 1,
  onPageSelect = (value) => {},
  onSortClick = (key, value) => {},
  filterApplied = false,
  showFileName = false,
  fileData = {},
  showLoader = false,
  icon = <></>,
  toolTipMessage = '',
  showNoRecordComp = false,
  onNoRecordEditBtnClick = () => {},
  showSearchFilterOptions = false,
  sitesLoading = false,
  isRowSpanEnabled = false,
  isPoolingCompleted = false,
  showEditExcelButtonLoader = false,
  isAOI = false,
  parentClassname = '',
  addressResolutionAOIComponent = false
}) => {
  const [tableColumns, setTableColumns] = useState([]);
  const [editFileMeta, setEditFileMeta] = useState('');
  let keyMap = {};
  let uniqueKeyLookUp = {};

  useEffect(() => {
    if (fileData && fileData.name) {
      setEditFileMeta(fileData);
    }
  }, [fileData]);

  useEffect(() => {
    const showShimmer = processSiteProcessed > dataPerPageValue['key'] * currentPage;
    const shimmerColCount = cols?.length > 10 && showShimmer ? Math.abs(dataPerPageValue['key'] - cols.length) : 0;

    const shimmerColElements = [];

    for (let i = 0; i < shimmerColCount; i++) {
      let shimmerRows = {};
      for (let j = 1; j <= rows.length; j++) {
        shimmerRows[`col${j}`] = null;
      }

      shimmerColElements.push(shimmerRows);
    }

    if (filterApplied || processSiteProcessed < dataPerPageValue['key']) {
      setTableColumns([...cols]);
    } else {
      setTableColumns([...cols, ...shimmerColElements]);
    }
  }, [dataPerPageValue, cols, processSiteProcessed]);
  const HeaderContent = () => (
    <div className={`accordion_header ${isAOI ? 'aoi_header' : ''}`}>
      {showProcessComponent && (
        <ProcessComponent
          addressResolutionAOIComponent={addressResolutionAOIComponent}
          showProcessConfigSection={showProcessConfigSection}
          processIdLabel={processIdLabel}
          processId={processId}
          processSiteProcessed={processSiteProcessed}
          processSiteLabel={processSiteLabel}
          processBtnName={processBtnName}
          processBtnDisabled={processBtnDisabled}
          onProcessBtnClick={onProcessBtnClick}
          icon={icon}
          toolTipMessage={toolTipMessage}
          sitesLoading={sitesLoading}
          showEditExcelButtonLoader={showEditExcelButtonLoader}
          isAOI={isAOI}
          hasValidStatusMap={
            locationStatusMap?.[FEASIBILITY_LOCATION_STATUS.ADDRESS_INCOMPLETE] > 0 ||
            feasibleSites ||
            manualFeasibleSites ||
            notFeasibleSites ||
            pendingFeasibleSites ||
            pendingForThirdPartySites
          }
        />
      )}
      <div className="sub_head">
        {locationStatusMap?.[FEASIBILITY_LOCATION_STATUS.ADDRESS_INCOMPLETE] > 0 && !isAOI && (
          <div className="address_status">
            {/* <img src={Alert_icon} alt="Alert" /> */}
            {locationStatusMap?.[FEASIBILITY_LOCATION_STATUS.ADDRESS_INCOMPLETE]}{' '}
            {locationStatusMap?.[FEASIBILITY_LOCATION_STATUS.ADDRESS_INCOMPLETE] > 1 ? 'Locations' : 'Location'} with incomplete address.
          </div>
        )}
        {showFeasibilityErrorStatus && (
          <StatusList
            feasibleSites={feasibleSites}
            manualFeasibleSites={manualFeasibleSites}
            notFeasibleSites={notFeasibleSites}
            pendingFeasibleSites={pendingFeasibleSites}
            pendingForThirdPartySites={pendingForThirdPartySites}
            incompleteAddr={locationStatusMap?.[FEASIBILITY_LOCATION_STATUS.ADDRESS_INCOMPLETE]}
          />
        )}
        {showTableData && showFileName && editFileMeta['name'] && (
          <ul className="edit-file-section">
            <li onClick={downloadFile.bind(null, editFileMeta['name'], editFileMeta)}>File Uploaded: {editFileMeta['name']}</li>
          </ul>
        )}
        
      </div>
      {isAOI && showDownloadReport && (
        <div>
            <Tooltip message={toolTipMessage}>
              <Button onClick={onProcessBtnClick} disabled={processBtnDisabled || showEditExcelButtonLoader}>
                {processBtnName}
                
                {processBtnDisabled && !showEditExcelButtonLoader && <span className="loading_icon"></span>}
              </Button>
            </Tooltip>
          </div>
        )}
    </div>
  );

  const downloadFile = (name, file) => {
    FileSaver.saveAs(file, name);
  };

  const getInvalidErrorMessage = () => {
    if (getProductType() === PRODUCT_TYPE.NLD) {
      return FEASIBILITY_MESSAGE.INVALID_ADDRESS_NLD;
    }

    return FEASIBILITY_MESSAGE.INVALID_ADDRESS_LL;
  };

  const renderTableContent = (hasAccordion) => {
    if (showNoRecordComp && !showLoader && !filterApplied && cols.length === 0) {
      return <NoRecord emptySites onClearFilter={onClearFilter} />;
    }

    const addRowLine = (id) => {
      let flag = false;
      if (keyMap.hasOwnProperty(id)) {
        return delete keyMap[id];
      }
      keyMap[id] = id;
      return flag;
    };

    const generateIdLookUp = (tableColumns = []) => {
      uniqueKeyLookUp = {};
      tableColumns.map((item) => {
        const id = typeof item['col1']?.data === 'object' ? item['col1']?.key : item['col1']?.data;
        uniqueKeyLookUp[id] = (uniqueKeyLookUp[id] || 0) + 1;
      });
    };

    const isHavingTwoLink = (id = '') => {
      return uniqueKeyLookUp[id] === 2;
    };

    const getColumns = (item, shouldAddRowSeparator) => {
      return Object.entries(item).map(([key, value]) => {
        if (value) {
          const { data = '', subData = '', hasError = false, locationStatus, expandRow = false, rowSpan = 0, key } = value;

          let tdProperties = { className: '' };
          const id = typeof data === 'object' ? key : data;
          if (isHavingTwoLink(id)) {
            if (!shouldAddRowSeparator && expandRow) {
              tdProperties['rowspan'] = rowSpan;
              tdProperties['className'] = 'expand_row';
            }
            if (shouldAddRowSeparator && expandRow) {
              return null;
            }
          }
          return (
            <td key={key} {...tdProperties}>
              <div className="b2b-lib-td_value">{data}</div>
              {subData && <div className="subvalue">{subData}</div>}
              {hasError && (
                <div className="subvalue" style={{ color: '#ef8d07' }}>
                  <img src={Alert_icon} alt="Alert" /> Incomplete
                </div>
              )}
              {locationStatus === FEASIBILITY_LOCATION_STATUS.RESOLVED && isAOI && (
                <div className="subvalue" style={{ color: '#16B27E' }}>
                  {/* <img src={Alert_icon} alt="Alert" />  */}
                  Resolved
                </div>
              )}
              {locationStatus === FEASIBILITY_LOCATION_STATUS.ADDRESS_COMPLETE && isAOI && (
                <div className="subvalue" style={{ color: '#16B27E' }}>
                  {/* <img src={Alert_icon} alt="Alert" />  */}
                  Resolved
                </div>
              )}
              {locationStatus === FEASIBILITY_LOCATION_STATUS.NEARBY_LOCATIONS && isAOI && (
                <div className="subvalue" style={{ color: '#ef8d07' }}>
                  <img src={Alert_icon} alt="Alert" />
                  Nearby Locations
                </div>
              )}
              {locationStatus === FEASIBILITY_LOCATION_STATUS.UNRESOLVED && isAOI && (
                <div className="subvalue" style={{ color: '#9F544D' }}>
                  <img src={Alert_red} alt="Alert" />
                  Unresolved
                </div>
              )}
              {locationStatus === FEASIBILITY_LOCATION_STATUS.INCORRECT_DETAILS && isAOI && (
                <div className="subvalue" style={{ color: '#ED4F42' }}>
                  <img src={Alert_red} alt="Alert" />
                  {/* Incorrect Details */}
                  Incomplete
                </div>
              )}
              {locationStatus === FEASIBILITY_LOCATION_STATUS.INVALID_ADDRESS && (
                <div className="subvalue" style={{ color: '#ef8d07' }}>
                  <img src={Cross_icon} alt="Error" /> <span className="errorTxt"> {getInvalidErrorMessage()} </span>
                </div>
              )}
            </td>
          );
        } else {
          return (
            <td key={key}>
              <div class="text text_m">
                <span class="visual"></span>
              </div>
            </td>
          );
        }
      });
    };

    const getBody = (tableColumns) => {
      generateIdLookUp(tableColumns);

      const lastIndex = tableColumns.length - 1;
      return (
        tableColumns.length > 0 &&
        tableColumns.map((item, index) => {
          const id = typeof item['col1']?.data === 'object' ? item['col1']?.key : item['col1']?.data;
          const shouldAddRowSeparator = addRowLine(id);
          let rowClassName = '';
          if (isRowSpanEnabled) {
            rowClassName = shouldAddRowSeparator ? 'hide_border' : '';
          }
          return (
            <tr key={index + item['col1']?.data} className={rowClassName}>
              {getColumns(item, shouldAddRowSeparator, rowClassName, index)}
            </tr>
          );
        })
      );
    };
    return (filterApplied && showLoader) || (cols.length === 0 && !filterApplied && !isPoolingCompleted) ? (
      <TableLoaderComponent />
    ) : (
      <div className={`table_card table_shimmer ${parentClassname}`}>
        <div className={`shimmer_box`}>
          {!hasAccordion && (
            <div className="table_header">
              <div className={`inside_header table_head_shimmer `}>
                <HeaderContent />
              </div>
            </div>
          )}
          {showTableData && (
            <Fragment>
              {!isAOI && (
                <div className="filter_strip">
                  {showProgressComponent && (
                    <div className="filter_left">
                      <ProgressComponent noOfProcessingSites={noOfProcessingSites} percentageComplete={percentageComplete} />
                    </div>
                  )}
                  {!showProgressComponent && locationStatusMap?.[FEASIBILITY_LOCATION_STATUS.INVALID_ADDRESS] > 0 && (
                    <div className="address_status">
                      <span className="grey_text ">
                        *
                        {`${Math.floor(
                          locationStatusMap?.[FEASIBILITY_LOCATION_STATUS.INVALID_ADDRESS] / 2
                        )} of ${processSiteProcessed} links have errors. Kindly rectify with help of `}{' '}
                        <span className="errorTxt link" onClick={onProcessBtnClick}>
                          Edit with Excel.
                        </span>
                      </span>
                    </div>
                  )}
                  <div className="searchFilter">
                    {!isAOI && showFilterOptions && (
                      <div className="bandwidth_type">
                        <Select label={filterLabel} value={filterValue} onChange={filterOnChange} options={filterOptions} variant="compact" />
                      </div>
                    )}
                    {showSearchFilterOptions && (
                      <SearchFilter
                        searchType={searchType}
                        onSearchTypeChange={onSearchTypeChange}
                        searchTypeOptions={searchTypeOptions}
                        searchValue={searchValue}
                        onSearchValueChange={onSearchValueChange}
                        filterOptions={searchFilterOptions}
                        onSearchClick={onSearchClick}
                        variant="compact"
                      />
                    )}
                  </div>
                </div>
              )}
              {showProgressComponent && isAOIOrder() && (
                <div className="filter_left polling-loader">
                  <ProgressComponent noOfProcessingSites={noOfProcessingSites} percentageComplete={percentageComplete} />
                </div>
              )}
              <div className="b2b-lib-dataTable">
                <Table>
                  <table className="content_table">
                    <thead>
                      <tr>
                        {rows.length > 0 &&
                          rows.map((item, index) => (
                            <th key={index}>
                              <div className="b2b-lib-data_head">
                                <span className="b2b-lib-title_text">{item.headerName}</span>
                                {item.isSortable && <span className={item.sortValue} role="button" tabIndex="0" onClick={() => onSortClick(item.sortKey, item.sortValue)}></span>}
                              </div>
                            </th>
                          ))}
                      </tr>
                    </thead>
                    <tbody>{getBody(cols)}</tbody>
                  </table>
                  {cols.length === 0 && <NoRecord onClearFilter={onClearFilter} />}
                </Table>
              </div>
              <div className="table-footer">
                {cols.length >= 10 ? (
                  <Select label={dataPerPageLabel} value={dataPerPageValue} onChange={dataPerPageOnChange} options={dataPerPageOptions} variant="compact" />
                ) : (
                  <div></div>
                )}
                <Pagination currentPage={currentPage} totalPages={totalPages} length={10} onPageSelect={onPageSelect} />
              </div>
            </Fragment>
          )}
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      {showSubHeader && <SubHeader productTitle={productTitle} handleGoBack={handleGoBack} />}
      <section className={`multi_site_section ${setBottomMargin ? 'plan-page' : ''}`}>
        <div className="multi_site_card">
          {hasAccordion ? (
            <Accordion title={<HeaderContent />} isExpanded={isAccordionExpanded} autoScrollOnExpand={false} onExpandClick={() => setIsAccordionExpanded(!isAccordionExpanded)}>
              {renderTableContent(true)}
            </Accordion>
          ) : (
            renderTableContent(false)
          )}
        </div>
      </section>
    </Fragment>
  );
};

export default AddressProcess;
